<template>
  <v-layout row justify-center align-center>
    <v-flex xs12>
      <v-card>
        <errors-list :errorMessage="error.errorMessage" />
        <v-form ref="form" @submit.prevent="onSubmit" color="green">
          <v-card-text>
            <v-card-text>
              <v-text-field
                v-model="status"
                :item-disabled="filterStatuses"
                :items="statuses"
                color="green darken-1"
                :label="$t('@debtForm/statusInputLabel')"
                :error-messages="validationError(error.errorField, errorFieldMap.status)"
                disabled
                required
              ></v-text-field>
              <v-text-field
                v-model="periodFrom"
                color="green darken-1"
                :label="$t('@debtForm/periodFromInputLabel')"
                disabled
                readonly
                name="periodFrom"
              />
              <v-text-field
                v-model="periodTill"
                color="green darken-1"
                :label="$t('@debtForm/periodTillInputLabel')"
                disabled
                readonly
                name="periodTill"
              />
              <v-text-field
                v-model="periodCost"
                color="green darken-1"
                :label="$t('@debtForm/periodCostInputLabel')"
                :disabled="submitting || disabledSelect"
                type="number"
                name="periodCost"
                :error-messages="validationError(error.errorField, errorFieldMap.periodCost)"
                required
              />
            </v-card-text>
          </v-card-text>

          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn :disabled="submitting" color="red darken-1" flat @click="closeModal(false)">
              {{ $t('@debtForm/cancelButtonLabel') }}
            </v-btn>

            <v-btn type="submit" :disabled="!isFormDirty || submitting" color="green darken-1" flat>
              {{ $t('@debtForm/submitButtonLabel') }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { defaultDateFormatter, defaultCostFormatter } from '../../utils';
import { validationError, getErrorObject } from '../../errorHandlers';
import ErrorsList from '../../components/ErrorsList';

const stateTransition = {
  paid: [],
  terminated: [],
  planned: ['planned'],
};

const errorFieldMap = {
  status: 'status',
  periodCost: 'periodCost',
};

export default {
  components: { ErrorsList },
  props: {
    debt: {
      type: Object,
    },
  },

  data() {
    const { periodFrom, periodTill, status, periodCost = 0 } = this.debt || {};
    return {
      submitting: false,
      error: {
        errorMessage: '',
        errorField: '',
      },
      isFormDirty: false,
      statuses: [
        { text: this.$t('@debtForm/plannedStatusLabel'), value: 'planned' },
        { text: this.$t('@debtForm/processedStatusLabel'), value: 'processed' },
        { text: this.$t('@debtForm/terminatedStatusLabel'), value: 'terminated' },
      ],
      periodFrom: defaultDateFormatter(periodFrom),
      periodTill: defaultDateFormatter(periodTill),
      status,
      periodCost: defaultCostFormatter(periodCost),
      validationError,
      errorFieldMap,
    };
  },

  computed: {
    disabledSelect() {
      return !(stateTransition[this.status] || []).length;
    },
  },

  watch: {
    status() {
      this.onChange();
    },

    periodCost() {
      this.onChange();
    },
  },

  methods: {
    closeModal(isSent = false) {
      this.$emit('close-modal', isSent);
    },

    filterStatuses({ value }) {
      return !(stateTransition[this.status] || []).find((v) => v === value);
    },

    onChange() {
      if (!this.isFormDirty) {
        this.isFormDirty = true;
      }

      if (this.error.errorMessage) {
        this.error = { errorMessage: '', errorField: '' };
      }
    },

    async onSubmit() {
      const { status, periodCost } = this;
      const paidNumber = +periodCost;

      try {
        if (!status) {
          this.error = {
            errorMessage: this.$t('@debtForm/emptyStatusErrorMessage'),
            errorField: errorFieldMap.status,
          };
          return;
        }
        if (isNaN(paidNumber) || paidNumber < 0) {
          this.error = {
            errorMessage: this.$t('@debtForm/invalidPeriodCostErrorMessage'),
            errorField: errorFieldMap.periodCost,
          };

          return;
        }

        this.submitting = true;
        await this.$http.put(`/api/debts/${this.debt.id}`, {
          status,
          periodCost: paidNumber,
        });
        this.closeModal(true);
      } catch (e) {
        this.error = getErrorObject(e);
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>
